export default {"src":"/_next/static/media/specialise-with-pathways.edd6cb6d.svg","height":644,"width":664,"blurWidth":0,"blurHeight":0};